// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__ZLi7Q","text":"Button_text__dBwXG","right":"Button_right__YJ9yq","top_right":"Button_top_right__JcCjC","green":"Button_green__fTSJS"};